import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ul>
      <li parentName="ul">{`Make sure that the payment methods are properly configured on your Dashboard, and that at least one payment method can be displayed with the data provided in the client session.`}</li>
      <li parentName="ul">{`Make sure that `}<inlineCode parentName="li">{`allowedPaymentMethods`}</inlineCode>{` does not disallow all your supported payment methods.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      